export default "__VITE_ASSET__CpEZRcO8__"